import { Wallet } from '@silo/ui';
import { useDoApprove, useQueryApproval } from '../common/ActionForm';
import { useDoDeposit } from './DepositForm';
import { DepositPanel } from './DepositPanel';

export function DepositPanelController(): JSX.Element {
  const queryApproval = useQueryApproval();
  const doApprove = useDoApprove();
  const doDeposit = useDoDeposit();

  return (
    <DepositPanel
      queryApproval={queryApproval}
      doApprove={doApprove}
      doDeposit={doDeposit}
      wallet={<Wallet.ConnectWallet />}
    />
  );
}
